import React from 'react';
import { useProductHat } from '@wix/package-picker-shared-eclipse';
import { AiPlanRecommendationCard } from '../../AiPlanRecommendationCard';
import { AiPlanRecommendationBannerDummy } from '../../AiPlanRecommendationCard/AiPlanRecommendationBannerDummy';
import type { AiBannerPlacement } from './getAiBannerPlacement';
import s from './ProductCard.scss';

interface CardHatSlotProps {
  productId: string;
  bannerPlacement: AiBannerPlacement;
  dummyPlacement: AiBannerPlacement;
}

export const CardHatSlot = ({
  productId,
  bannerPlacement,
  dummyPlacement,
}: CardHatSlotProps) => {
  const { renderProductHat } = useProductHat({ productId });

  if (bannerPlacement === 'hat') {
    return <AiPlanRecommendationCard bannerPlacement="hat" />;
  }

  if (dummyPlacement === 'hat') {
    return (
      <div className={s.hatStack}>
        {renderProductHat()}
        <AiPlanRecommendationBannerDummy placement="hat" />
      </div>
    );
  }

  return renderProductHat();
};
